import $ from 'jquery';

const Alert = {
  isActive: false,

  // Get message from flash message, then show it
  getMessage() {
    $.getJSON('/flash-message/view.json', function(data) {
      if(data.message) Alert.show({ level: 'warning', message: data.message });
    });
  },

  // accepts alert level & message, then shows it
  show(options) {
    if(this.isActive) return;

    var markup =
    '<div class="alert alert-' + options.level + '" id="alert" style="display: none;">' +
      '<button type="button" class="close" data-dismiss="alert">&times;</button> ' +
      options.message +
    '</div>';

    this.isActive = true;
    $('body').append(markup);
    $('#alert').fadeIn();

    setTimeout(function() {
      Alert.destroy();
      Alert.isActive = false;
    }, 3000);
  },

  // hides alert, then destroys it
  destroy() {
    $('#alert').fadeOut({
      done: function() { $(this).remove();}
    });
  }
};

export default Alert;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/alert.js